import * as React from "react";

import "./Icon.css";

const SvgLogInIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Log_In_Icon_svg_Layer_1"
    data-name="Layer 1"
    viewBox="0 0 60 60"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <defs>
      <style>{".Log_In_Icon_svg_cls-1{fill:currentColor}"}</style>
    </defs>
    <g transform="translate(6 6)">
      <path
        d="M5.77 5.55h29.42V0H0v48h35.19v-5.55H5.77z"
        className="Log_In_Icon_svg_cls-1"
      />
      <path
        d="M22.38 21.31v-6.47L13.18 24l9.2 9.16v-6.47H48v-5.38z"
        className="Log_In_Icon_svg_cls-1 arrow"
      />
    </g>
  </svg>
);
export default SvgLogInIcon;
